import setAllowedOptions from '../mutators/setAllowedOptions';
import getAllowedOptions from '../services/getAllowedOptions';

let allowedOptionsPromise: Promise<void> | undefined = undefined;

export default function loadAllowedOptions() {
    if (!allowedOptionsPromise) {
        allowedOptionsPromise = getAllowedOptions().then(response =>
            setAllowedOptions(response.AllowedOptions)
        );
    }
    return allowedOptionsPromise;
}
